module.exports = __webpack_public_path__ + "static/cdlsi-logo-beffb7c1bcfc36ec360861ba41a0adac.png";